<template>
  <div class="content-list">
    <template>
      <vs-collapse type="border">
        <vs-collapse-item-m :hidden="withSelection" open>
          <div slot="header">Filters</div>
          <div class="flex w-full pb-5 searcheable-fields">
            <div class="w-1/3 pr-3 type-field">
              <label class="vs-input--label">Content type</label>
              <v-select
                v-model="typeSelected"
                :clearable="false"
                placeholder="Select one"
                :options="filterTypeOptions"
              />
            </div>
            <div class="w-2/3 pl-3 name-field">
              <label class="vs-input--label">Content name or ID</label>
              <vs-input
                class="w-full"
                placeholder=""
                v-model="name"
                @keyup.enter.native="searchContent"
              />
            </div>
          </div>

          <div
            class="course-async-api-data conditional-fields vs-con-loading__container"
            v-show="typeSelected === 'Course'"
          >
            <div class="flex flex-wrap">
              <div class="w-1/3 pb-5 pr-3">
                <label class="vs-input--label">Instructor</label>
                <v-select
                  multiple
                  v-model="filterCourses.instructors"
                  :closeOnSelect="false"
                  :reduce="(instructor) => instructor.value"
                  placeholder="Select one or more"
                  :options="getInstructors"
                />
              </div>
              <div class="w-1/3 pb-5 pl-3 pr-3">
                <label class="vs-input--label">Difficulty</label>
                <v-select
                  v-model="filterCourses.difficulty"
                  placeholder="Select a level"
                  :reduce="(difficulty) => difficulty.value"
                  :options="getCourseDifficulties"
                />
              </div>
              <div class="w-1/3 pl-3 pb-5">
                <label class="vs-input--label">Learning Area</label>
                <v-select
                  multiple
                  v-model="filterCourses.learning_areas"
                  placeholder="Select an area"
                  :options="getLAreas"
                  :reduce="(la) => la.value"
                />
              </div>
              <div class="w-1/3 pb-5 pr-3">
                <label class="vs-input--label">Category</label>
                <v-select
                  multiple
                  v-model="filterCourses.categories"
                  placeholder="Select a category"
                  :reduce="(category) => category.value || null"
                  :options="getCategories"
                />
              </div>
              <div class="w-1/3 pb-5 pl-3 pr-3">
                <label class="vs-input--label">Vendor</label>
                <v-select
                  v-model="filterCourses.vendor"
                  placeholder="Select a vendor"
                  :reduce="(vendor) => vendor.value"
                  :options="getVendors"
                />
              </div>
              <div class="w-1/3 pl-3 pb-5">
                <label class="vs-input--label">Tags</label>
                <v-select
                  v-model="filterCourses.tags"
                  multiple
                  placeholder="Select one or more tags"
                  :options="tagsOptions"
                  :filterable="false"
                  @search="onSearchTags"
                >
                  <template slot="no-options">
                    type to search or add a tag
                  </template>
                </v-select>
              </div>
              <div class="w-1/3 pb-5 pr-3">
                <label class="vs-input--label">Status</label>
                <v-select
                  v-model="filterCourses.status"
                  placeholder="Select a status"
                  :reduce="(status) => status.value"
                  :options="getCourseAllStatus"
                />
              </div>
              <div class="w-1/3 pb-5 pl-3 pr-3">
                <label class="vs-input--label">Featured</label>
                <v-select
                  v-model="filterCourses.is_featured"
                  placeholder="Select featured option"
                  :reduce="(featured) => featured.value"
                  :options="isFeaturedOptions"
                  name="feature-field"
                />
              </div>
              <div class="w-1/3 pl-3 pb-5">
                <label class="vs-input--label">Closed captioning</label>
                <v-select
                  v-model="filterCourses.has_cc"
                  placeholder="Select closed captioning option"
                  :reduce="(cc) => cc.value"
                  :options="hasCCOptions"
                />
              </div>
              <div
                class="w-1/3 pr-3 pb-5"
                v-if="customContentCoursesEnabled"
              >
                <label class="vs-input--label">{{
                  customContentStrings.courseFilterContentTypeLabel
                }}</label>
                <v-select
                  class="course-access-type-filter"
                  v-model="filterCourses.audience_type"
                  :placeholder="
                    customContentStrings.courseFilterContentTypePlaceholder
                  "
                  :reduce="(accessType) => accessType.value"
                  :options="courseAccessTypeOptions"
                />
              </div>
              <div
                class="w-2/3 pl-3 pb-5"
                v-if="customContentCoursesEnabled"
              >
                <label class="vs-input--label">{{
                  customContentStrings.enterpriseAccountsLabel
                }}</label>
                <v-select
                  ref="courseFilterAccountsSelect"
                  class="course-enterprise-accounts-filter"
                  multiple
                  v-model="filterCourses.business_account_ids"
                  :closeOnSelect="false"
                  :disabled="
                    filterCourses.audience_type !==
                      CUSTOM_CONTENT_AUDIENCE_TYPES.CUSTOM
                  "
                  :loading="enterpriseAccountsLoading"
                  :dropdownShouldOpen="enterpriseAccountsDropdownShouldOpen"
                  :autoscroll="false"
                  :reduce="(account) => account.value"
                  :placeholder="customContentStrings.enterpriseAccountsPlaceholder"
                  :options="enterpriseAccountFilterOptions"
                  :filterable="false"
                  @search="onSearchEnterpriseAccounts"
                  @open="onOpenEnterpriseAccounts"
                >
                  <template slot="no-options">
                    {{ enterpriseAccountsFilterNoOptionsText }}
                  </template>
                </v-select>
              </div>
            </div>
          </div>
          <div
            class="course-async-api-data conditional-fields vs-con-loading__container"
            v-show="typeSelected === 'Learning Path'"
          >
            <div class="flex flex-wrap">
              <div class="w-1/3 pb-5 pr-3">
                <label class="vs-input--label">Difficulty</label>
                <v-select
                  v-model="filterLPaths.difficulty"
                  placeholder="Select a level"
                  :reduce="(difficulty) => difficulty.value"
                  :options="getLPathDifficulties"
                />
              </div>
              <div class="w-1/3 pb-5 pl-3 pr-3">
                <label class="vs-input--label">Learning Area</label>
                <v-select
                  multiple
                  v-model="filterLPaths.learning_areas"
                  placeholder="Select an area"
                  :options="getLAreas"
                  :reduce="(la) => la.value"
                />
              </div>
              <div class="w-1/3 pb-5 pl-3">
                <label class="vs-input--label">Category</label>
                <v-select
                  multiple
                  v-model="filterLPaths.categories"
                  placeholder="Select a category"
                  :reduce="(category) => category.value || null"
                  :options="getCategories"
                />
              </div>
              <div class="w-1/3 pb-5 pr-3">
                <label class="vs-input--label">Vendor</label>
                <v-select
                  v-model="filterLPaths.vendor"
                  placeholder="Select a vendor"
                  :reduce="(vendor) => vendor.value"
                  :options="getVendors"
                />
              </div>
              <div class="w-1/3 pb-5 pl-3 pr-3">
                <label class="vs-input--label">Tags</label>
                <v-select
                  v-model="filterLPaths.tags"
                  multiple
                  placeholder="Select one or more tags"
                  :options="tagsOptions"
                  :filterable="false"
                  @search="onSearchTags"
                >
                  <template slot="no-options">
                    type to search or add a tag
                  </template>
                </v-select>
              </div>
              <div class="w-1/3 pb-5 pl-3">
                <label class="vs-input--label">Status</label>
                <v-select
                  v-model="filterLPaths.status"
                  placeholder="Select a status"
                  :reduce="(status) => status.value"
                  :options="getLPathAllStatus"
                />
              </div>
              <div class="w-1/3 pb-5 pr-3">
                <label class="vs-input--label">Featured</label>
                <v-select
                  v-model="filterLPaths.is_featured"
                  placeholder="Select featured state"
                  :reduce="(featured) => featured.value"
                  :options="isFeaturedOptions"
                />
              </div>
              <div class="w-1/3 pr-3 pl-3 pb-5">
                <label class="vs-input--label">Closing JW Player Id</label>
                <vs-input
                  class="w-full"
                  placeholder=""
                  v-model="filterLPaths.closing_video_jwplayer_id"
                  @keyup.enter.native="searchContent"
                />
              </div>
            </div>
          </div>
          <div v-show="typeSelected === 'Quiz'">
            <div class="w-full video-reference-field">
              <label class="vs-input--label">Video reference</label>
              <vs-input
                class="w-full"
                placeholder=""
                v-model="filterQuizzes.video_reference"
                @keyup.enter.native="searchContent"
              />
            </div>
          </div>
          <div v-show="typeSelected === 'Video'">
            <div class="flex flex-wrap">
              <div
                :class="
                  customContentVideosEnabled
                    ? 'w-1/4 pb-5 pr-3'
                    : 'w-1/3 pb-5 pr-3'
                "
              >
                <label class="vs-input--label">Instructor</label>
                <v-select
                  v-model="filterVideos.instructor_id"
                  :reduce="(instructor) => instructor.value"
                  placeholder="Select an instructor"
                  :options="getInstructors"
                />
              </div>
              <div
                :class="
                  customContentVideosEnabled
                    ? 'w-1/4 pl-3 pb-5 pr-3'
                    : 'w-1/3 pl-3 pb-5 pr-3'
                "
              >
                <label class="vs-input--label">Type</label>
                <v-select
                  v-model="filterVideos.type"
                  placeholder="Select a type option"
                  :reduce="(type) => type.value"
                  :options="videoTypeOptionsFiltered"
                  :clearable="!videoTypeOptionsFiltered.length"
                />
              </div>
              <div
                class="w-1/4 pl-3 pb-5 pr-3"
                v-if="customContentVideosEnabled"
              >
                <label class="vs-input--label">{{
                  customContentStrings.courseFilterContentTypeLabel
                }}</label>
                <v-select
                  class="video-access-type-filter"
                  v-model="filterVideos.audience_type"
                  :placeholder="
                    customContentStrings.courseFilterContentTypePlaceholder
                  "
                  :reduce="(accessType) => accessType.value"
                  :options="courseAccessTypeOptions"
                />
              </div>
              <div
                :class="
                  customContentVideosEnabled
                    ? 'w-1/4 pl-3 pb-5'
                    : 'w-1/3 pl-3 pb-5'
                "
              >
                <label class="vs-input--label">S3 video Url</label>
                <vs-input
                  class="w-full"
                  placeholder="Enter S3 video Url"
                  v-model="filterVideos.s3_video_url"
                  @keyup.enter.native="searchContent"
                />
              </div>
            </div>
          </div>
          <div v-show="typeSelected === 'Lab'">
            <div class="flex flex-wrap">
              <div class="w-1/4 pr-3 pb-5">
                <label class="vs-input--label">Type</label>
                <v-select
                  v-model="filterLabs.lab_type"
                  placeholder="Select a type option"
                  :reduce="(lab_type) => lab_type.value"
                  :options="labTypeOptions"
                />
              </div>
              <div class="w-1/4 pl-3 pr-3 pb-5">
                <label class="vs-input--label">Status</label>
                <v-select
                  v-model="filterLabs.status"
                  placeholder="Select a status"
                  :reduce="(status) => status.value"
                  :options="getLabAllStatus"
                />
              </div>
              <div class="w-1/4 pl-3 pr-3 pb-5">
                <label class="vs-input--label">Is Skill Dive Lab</label>
                <v-select
                  v-model="filterLabs.is_lab_experience"
                  placeholder="Select 'true' or 'false'"
                  :options="['true', 'false']"
                />
              </div>
              <div class="w-1/4 pl-3 pb-5">
                <label class="vs-input--label">Is Featured</label>
                <v-select
                  v-model="filterLabs.is_featured"
                  placeholder="Select 'true' or 'false'"
                  :options="['true', 'false']"
                />
              </div>
              <div class="w-1/4 pr-3 pb-5">
                <label class="vs-input--label">Is Skill Check</label>
                <v-select
                  v-model="filterLabs.is_skill_check"
                  placeholder="Select 'true' or 'false'"
                  :options="['true', 'false']"
                />
              </div>

              <div class="w-1/4 pl-3 pr-3 pb-5">
                <label class="vs-input--label">Severity</label>
                <v-select
                  v-model="filterLabs.severity"
                  placeholder="Select a severity"
                  :options="labSeverityOptions"
                  :reduce="(severity) => severity.value"
                />
              </div>
              <div class="w-1/4 pl-3 pr-3 pb-5">
                <label class="vs-input--label">Year</label>
                <v-select
                  placeholder="Select year"
                  v-model="filterLabs.year"
                  :options="labYearOptions"
                />
              </div>
              <div class="w-1/4 pl-3 pr-3 pb-5">
                <label class="vs-input--label">CVE</label>
                <vs-input
                  @keyup.enter.native="searchContent"
                  v-mask="'CVE-####-#####'"
                  v-model="filterLabs.cve"
                  placeholder="CVE-YYYY-#####"
                  class="w-full cve-field"
                />
              </div>
            </div>
          </div>
          <div v-show="typeSelected === 'iFrame'">
            <div class="flex flex-wrap">
              <div class="w-1/3 pr-3 pb-5">
                <label class="vs-input--label">Type</label>
                <v-select
                  v-model="filterIFrames.type"
                  placeholder="Select a type option"
                  :reduce="(type) => type.value"
                  :options="iframeTypeOptions"
                />
              </div>
            </div>
          </div>
          <div
            class="collection-async-api-data conditional-fields vs-con-loading__container"
            v-show="typeSelected === 'Collection'"
          >
            <div class="flex flex-wrap">
              <div class="w-1/3 pb-5 pr-3">
                <label class="vs-input--label">Difficulty</label>
                <v-select
                  v-model="filterCollections.difficulty"
                  placeholder="Select a level"
                  :reduce="(difficulty) => difficulty.value"
                  :options="getCollectionDifficulties"
                />
              </div>
              <div class="w-1/3 pl-3 pr-3 pb-5">
                <label class="vs-input--label">Learning Area</label>
                <v-select
                  multiple
                  v-model="filterCollections.learning_areas"
                  placeholder="Select an area"
                  :options="getLAreas"
                  :reduce="(la) => la.value"
                />
              </div>
              <div class="w-1/3 pl-3 pb-5">
                <label class="vs-input--label">Category</label>
                <v-select
                  multiple
                  v-model="filterCollections.categories"
                  placeholder="Select a category"
                  :reduce="(category) => category.value || null"
                  :options="getCategories"
                />
              </div>
              <div class="w-1/3 pr-3 pb-5">
                <label class="vs-input--label">Tags</label>
                <v-select
                  v-model="filterCollections.tags"
                  multiple
                  placeholder="Select one or more tags"
                  :options="tagsOptions"
                  :filterable="false"
                  @search="onSearchTags"
                >
                  <template slot="no-options">
                    type to search or add a tag
                  </template>
                </v-select>
              </div>
              <div class="w-1/3 pb-5 pl-3 pr-3">
                <label class="vs-input--label">Status</label>
                <v-select
                  v-model="filterCollections.status"
                  placeholder="Select a status"
                  :reduce="(status) => status.value"
                  :options="getCollectionAllStatus"
                />
              </div>
              <div class="w-1/3 pb-5 pl-3">
                <label class="vs-input--label">Featured</label>
                <v-select
                  v-model="filterCollections.is_featured"
                  placeholder="Select featured option"
                  :reduce="(featured) => featured.value"
                  :options="isFeaturedOptions"
                  name="feature-field"
                />
              </div>
            </div>
          </div>
          <div class="flex w-full action-buttons">
            <vs-button class="self-end mt-5 ml-auto" @click="searchContent">
              Search
            </vs-button>
          </div>
        </vs-collapse-item-m>
      </vs-collapse>
    </template>
    <content-list-table
      :items="items"
      :typeSelected="typeSelected"
      :pageSize="pageSize"
      :columnsByType="columnsByType"
      :relatedContentByType="relatedContentByType"
      :rowsOpened="rowsOpened"
      :rowsLoading="rowsLoading"
      :withSelection="withSelection"
      :filterLabs="filterLabs"
      :itemsSelected="itemsSelected"
      :editRouteResolver="resolveEditRoute"
      @change-page="handleChangePage"
      @sort="handleSort"
      @selected="goToItemClicked"
      @select-item="$emit('select-item', $event)"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { mapGetters, mapActions } from 'vuex'
import omitBy from 'lodash.omitby'
import isEmpty from 'lodash.isempty'
import isEqual from 'lodash.isequal'
import isNil from 'lodash.isnil'
import debounce from 'lodash.debounce'
import validate from 'uuid-validate'
import { searchTags, getBasicData } from '@/utils/mixins'
import { normalizeBusinessAccountIds } from '@/utils/utils'
import {
  mergeEnterpriseAccountOptionsInPlace,
  normalizeEnterpriseAccountsSearchTerm,
} from '@/utils/enterpriseAccounts'
import { resolveEditPathByType } from '@/utils/navigationHelper'
import {
  buildEnterpriseAccountsLoaderState,
  loadEnterpriseAccounts,
} from '@/services/contentManager.service'
import {
  CUSTOM_CONTENT_AUDIENCE_TYPES,
  CUSTOM_CONTENT_STRINGS,
} from '@/constants/customContent'
import ContentListTable from './components/ContentListTable.vue'
import { mask } from 'vue-the-mask'

export default {
  mixins: [searchTags, getBasicData],
  components: {
    'v-select': vSelect,
    ContentListTable,
  },
  directives: {
    mask,
  },
  props: {
    withSelection: Boolean,
    filterTypes: Array,
    itemsSelected: Object,
    videoOptions: {
      type: Array,
      required: false,
      default: () => {
        return []
      },
    },
  },
  data: () => ({
    CUSTOM_CONTENT_AUDIENCE_TYPES,
    customContentStrings: CUSTOM_CONTENT_STRINGS,
    selected: [],
    totalItems: 0,
    pageSize: 25,
    page: 1,
    ordering: null,
    items: {
      Course: {
        items: [],
        totalItems: 0,
      },
      Video: {
        items: [],
        totalItems: 0,
      },
      Pass: {
        items: [],
        totalItems: 0,
      },
      Quiz: {
        items: [],
        totalItems: 0,
      },
      'Learning Path': {
        items: [],
        totalItems: 0,
      },
      Exercise: {
        items: [],
        totalItems: 0,
      },
      Lab: {
        items: [],
        totalItems: 0,
      },
      iFrame: {
        items: [],
        totalItems: 0,
      },
      Bootcamp: {
        items: [],
        totalItems: 0,
      },
      Collection: {
        items: [],
        totalItems: 0,
      },
      SkillSonar: {
        items: [],
        totalItems: 0,
      },
    },
    typeSelected: 'Course',
    name: '',
    filterCourses: {
      difficulty: null,
      instructors: null,
      learning_areas: null,
      categories: null,
      tags: null,
      vendor: null,
      status: null,
      is_featured: null,
      has_cc: null,
      audience_type: null,
      business_account_ids: [],
    },
    filterLPaths: {
      difficulty: null,
      instructors: null,
      learning_areas: null,
      categories: null,
      tags: null,
      vendor: null,
      status: null,
      is_featured: null,
    },
    filterCollections: {
      difficulty: null,
      learning_areas: null,
      categories: null,
      tags: null,
      vendor: null,
      status: null,
      is_featured: null,
      has_cc: null,
      has_sample_content: null,
    },
    isFeaturedOptions: [
      { value: true, label: 'Is featured' },
      { value: false, label: 'Is not featured' },
    ],
    hasCCOptions: [
      { value: true, label: 'With closed captioning' },
      { value: false, label: 'Whitout closed captioning' },
    ],
    courseAccessTypeOptions: [
      {
        value: null,
        label: CUSTOM_CONTENT_STRINGS.courseFilterContentTypeAllLabel,
      },
      {
        value: CUSTOM_CONTENT_AUDIENCE_TYPES.PUBLIC,
        label: CUSTOM_CONTENT_STRINGS.courseFilterContentTypePublicLabel,
      },
      {
        value: CUSTOM_CONTENT_AUDIENCE_TYPES.CUSTOM,
        label: CUSTOM_CONTENT_STRINGS.courseFilterContentTypeCustomLabel,
      },
    ],
    enterpriseAccountOptions: [],
    enterpriseAccountsLoading: false,
    enterpriseAccountsLoaderState: buildEnterpriseAccountsLoaderState(),
    enterpriseAccountsSearchTerm: '',
    enterpriseAccountsDropdownShouldOpen: ({ noDrop, open }) =>
      !noDrop && open,
    videoTypeOptions: [
      { value: 'lesson', label: 'Lesson' },
      { value: 'lab_explanation', label: 'Lab Explanation' },
      { value: 'lab_solution', label: 'Lab Solution' },
      { value: 'ine_live', label: 'INE Live' },
    ],
    iframeTypeOptions: [{ value: 'slides', label: 'Slides' }],
    filterVideos: {
      instructor_id: null,
      type: null,
      audience_type: null,
    },
    filterExercises: {
      instructor_id: null,
    },
    filterLabs: {
      lab_type: null,
      status: null,
      is_lab_experience: null,
      is_featured: null,
      is_skill_check: null,
      severity: null,
      year: null,
      cve: null,
    },
    filterIFrames: {
      type: null,
    },
    filterQuizzes: {
      video_reference: null,
    },
    filterBootcamps: {
      instructor: null,
      status: null,
      registration_open: null,
    },
    filterSonar: {},
    registrationOpenOptions: [
      { value: true, label: 'Registration Opened' },
      { value: false, label: 'Registration Closed' },
    ],
    filterPasses: {},
    columnsByType: {
      Course: ['name', 'avg_rating', 'published_date', 'modified', 'status'],
      Video: ['name', 'jwplayer_id', 'modified', 'status', 'created'],
      Pass: ['name', 'created', 'modified'],
      Quiz: [
        'id',
        'created',
        'modified',
        'number_of_questions',
        'video_reference',
      ],
      'Learning Path': ['name', 'published_date', 'modified', 'status'],
      Exercise: ['name', 'created', 'modified'],
      Lab: [
        'name',
        'created',
        'lab_type',
        'pta_sdn',
        'els_lab_id',
        'modified',
        'status',
      ],
      iFrame: ['name', 'created', 'modified'],
      Bootcamp: [
        'name',
        'created',
        'modified',
        'start_datetime',
        'end_datetime',
        'zoom_webinar_id',
        'status',
      ],
      Collection: ['name', 'published_date', 'modified', 'status'],
      'Skill Sonar': ['name', 'created', 'modified', 'skill_area_id'],
    },
    relatedContentByType: {
      Video: ['courses', 'learning_paths'],
      Lab: ['courses', 'learning_paths', 'collections'],
      Collection: ['learning_paths'],
    },
    rowsLoading: [],
    rowsOpened: [],
    starsConfig: {
      rating: 0,
      isIndicatorActive: false,
      style: {
        fullStarColor: '#ed8a19',
        emptyStarColor: '#737373',
        starWidth: 10,
        starHeight: 10,
      },
    },
    searchEnterpriseAccountsDebounced: null,
  }),
  computed: {
    ...mapGetters('app', ['getSelectedCompany', 'getSelectedCompanyName']),
    ...mapGetters('vendors', ['getVendors']),
    ...mapGetters('instructors', ['getInstructors']),
    ...mapGetters('categories', ['getCategories']),
    ...mapGetters('lareas', ['getLAreas']),
    ...mapGetters('courses', [
      'getCourseDifficulties',
      'getCourseList',
      'getCourseAllStatus',
    ]),
    ...mapGetters('lpaths', [
      'getLPathDifficulties',
      'getLPathList',
      'getLPathAllStatus',
    ]),
    ...mapGetters('videos', ['getVideoList']),
    ...mapGetters('passes', ['getPassList']),
    ...mapGetters('quizzes', ['getQuizList']),
    ...mapGetters('exercises', ['getExerciseList']),
    ...mapGetters('labs', [
      'getLabList',
      'getLabAllStatus',
      'labTypeOptions',
      'labSeverityOptions',
      'labYearOptions',
    ]),
    ...mapGetters('iframes', ['getIFrameList']),
    ...mapGetters('sonar', ['getSonarList']),
    ...mapGetters('collections', [
      'getCollectionDifficulties',
      'getCollectionList',
      'getCollectionAllStatus',
    ]),
    ...mapGetters('featureFlags', [
      'customContentCoursesEnabled',
      'customContentVideosEnabled',
    ]),
    filterTypeOptions() {
      return this.filterTypes && this.filterTypes.length
        ? this.filterTypes
        : [
            'Course',
            'Video',
            'Quiz',
            'Learning Path',
            'Exercise',
            'Lab',
            'iFrame',
            'Collection',
            'Skill Sonar',
          ]
    },
    videoTypeOptionsFiltered() {
      if (!this.videoOptions.length) return this.videoTypeOptions
      const filtered = this.videoTypeOptions.filter((v) => {
        return this.videoOptions.includes(v.value)
      })
      return filtered
    },
    enterpriseAccountFilterOptions() {
      const optionsMap = this.enterpriseAccountOptions.reduce((acc, option) => {
        acc[option.value] = option
        return acc
      }, {})

      normalizeBusinessAccountIds(this.filterCourses.business_account_ids).forEach(
        (accountId) => {
          if (!optionsMap[accountId]) {
            optionsMap[accountId] = {
              value: accountId,
              label: accountId,
            }
          }
        }
      )

      const mergedOptions = Object.values(optionsMap)
      const normalizedSearchTerm = this.enterpriseAccountsSearchTerm
        .trim()
        .toLowerCase()
      if (!normalizedSearchTerm) {
        return mergedOptions
      }

      return mergedOptions.filter((option) =>
        String(option.label || '')
          .toLowerCase()
          .includes(normalizedSearchTerm)
      )
    },
    enterpriseAccountsFilterNoOptionsText() {
      if (
        this.filterCourses.audience_type !== CUSTOM_CONTENT_AUDIENCE_TYPES.CUSTOM
      ) {
        return this.customContentStrings.enterpriseAccountsNoOptionsDisabled
      }
      if (this.enterpriseAccountsSearchTerm) {
        return this.customContentStrings.enterpriseAccountsNoMatches
      }
      return this.customContentStrings.enterpriseAccountsNoOptionsEnabled
    },
  },
  methods: {
    ...mapActions('courses', [
      'getAllCourses',
      'searchCourses',
      'searchBusinessAccounts',
    ]),
    ...mapActions('lpaths', ['getAllLPaths', 'searchLPaths']),
    ...mapActions('videos', ['getAllVideos']),
    ...mapActions('passes', ['getAllPasses']),
    ...mapActions('quizzes', ['getAllQuizzes']),
    ...mapActions('exercises', ['getAllExercises']),
    ...mapActions('labs', ['getAllLabs']),
    ...mapActions('iframes', ['getAllIFrames']),
    ...mapActions('bootcamps', ['getAllBootcamps']),
    ...mapActions('collections', ['getAllCollections', 'searchCollections']),
    ...mapActions('sonar', ['getAllSonarAssessments']),
    mergeEnterpriseAccountOptions(accounts = []) {
      if (!Array.isArray(this.enterpriseAccountOptions)) {
        this.enterpriseAccountOptions = []
      }
      mergeEnterpriseAccountOptionsInPlace(this.enterpriseAccountOptions, accounts)
    },
    notifyEnterpriseAccountsLoadError() {
      this.$vs.notify({
        title: 'Error',
        text: this.customContentStrings.enterpriseAccountsLoadError,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        time: '3500',
      })
    },
    async loadEnterpriseAccountsForFilter({ query = '', ids = [] } = {}) {
      if (!this.customContentCoursesEnabled) return
      if (
        this.filterCourses.audience_type !== CUSTOM_CONTENT_AUDIENCE_TYPES.CUSTOM
      ) {
        return
      }

      this.enterpriseAccountsLoading = true
      try {
        const { response, stale } = await loadEnterpriseAccounts({
          searchBusinessAccounts: this.searchBusinessAccounts,
          loaderState: this.enterpriseAccountsLoaderState,
          query,
          ids,
        })
        if (!stale) {
          this.mergeEnterpriseAccountOptions(response.results || [])
        }
      } catch (error) {
        this.notifyEnterpriseAccountsLoadError()
      } finally {
        this.enterpriseAccountsLoading = false
      }
    },
    cancelSearchEnterpriseAccountsDebounced() {
      if (
        this.searchEnterpriseAccountsDebounced &&
        typeof this.searchEnterpriseAccountsDebounced.cancel === 'function'
      ) {
        this.searchEnterpriseAccountsDebounced.cancel()
      }
    },
    onOpenEnterpriseAccounts() {
      if (
        this.filterCourses.audience_type !== CUSTOM_CONTENT_AUDIENCE_TYPES.CUSTOM
      ) {
        return
      }
      this.enterpriseAccountsSearchTerm = ''
      this.loadEnterpriseAccountsForFilter({
        ids: this.filterCourses.business_account_ids,
      })
    },
    onSearchEnterpriseAccounts(search, loading) {
      const updateLoading =
        typeof loading === 'function' ? loading : () => {}
      const normalizedSearchTerm = normalizeEnterpriseAccountsSearchTerm(search)
      if (
        !this.customContentCoursesEnabled ||
        this.filterCourses.audience_type !== CUSTOM_CONTENT_AUDIENCE_TYPES.CUSTOM
      ) {
        this.cancelSearchEnterpriseAccountsDebounced()
        this.enterpriseAccountsSearchTerm = ''
        updateLoading(false)
        return
      }
      this.enterpriseAccountsSearchTerm = normalizedSearchTerm
      if (!normalizedSearchTerm) {
        updateLoading(false)
        return
      }
      updateLoading(true)
      this.searchEnterpriseAccountsDebounced(
        normalizedSearchTerm,
        updateLoading
      )
    },
    async ensureEnterpriseAccountOptions(ids = []) {
      const accountIds = normalizeBusinessAccountIds(ids)
      if (!accountIds.length) return
      await this.loadEnterpriseAccountsForFilter({ ids: accountIds })
    },
    handleChangePage(page) {
      this.page = page
      this.searchContent({
        page: this.page.toString(),
        ordering: this.ordering,
      })
    },
    handleSort(key, active) {
      if (key === 'no-sort') return
      this.ordering = `${active === 'desc' ? '-' : ''}${key}`
      this.page = 1
      this.searchContent({
        page: this.page,
        ordering: this.ordering,
      })
    },
    handleSearchContent() {
      // reset pagination data
      this.page = 1
      this.order = null
      this.searchContent()
    },
    async searchContent(payload = {}) {
      this.$vs.loading({
        container: '.search-async-api-data',
        scale: 0.6,
      })
      // check if user write a valid uuid
      if (
        this.name &&
        this.name.split(',').every((id) => {
          return validate(id.trim())
        })
      ) {
        this.name = this.name.replace(/\s/g, '')
        const arr = this.name.split(',')
        payload.ids = arr.length > 1 ? arr : this.name
      } else {
        payload.name__icontains = this.name ? `${this.name}` : null
      }
      if (!payload) return

      let results = []
      let totalItems = 0
      try {
        switch (this.typeSelected) {
          case 'Course':
            payload = {
              ...payload,
              instructors__in: this.filterCourses.instructors,
              learning_areas__in: this.filterCourses.learning_areas,
              categories__in: this.filterCourses.categories,
              tags__name__in: this.filterCourses.tags,
              vendor: this.filterCourses.vendor,
              difficulty: this.filterCourses.difficulty,
              status: this.filterCourses.status,
              is_featured: isNil(this.filterCourses.is_featured)
                ? this.filterCourses.is_featured
                : this.filterCourses.is_featured.toString(),
              has_cc: isNil(this.filterCourses.has_cc)
                ? this.filterCourses.has_cc
                : this.filterCourses.has_cc.toString(),
              audience_type: this.customContentCoursesEnabled
                ? this.filterCourses.audience_type
                : null,
              business_account_ids: this.customContentCoursesEnabled
                && this.filterCourses.audience_type === CUSTOM_CONTENT_AUDIENCE_TYPES.CUSTOM
                ? this.filterCourses.business_account_ids
                : [],
              page_size: this.pageSize.toString(),
            }
            await this.getAllCourses(payload)
            results = this.getCourseList.results
            totalItems = this.getCourseList.count
            break
          case 'Video': {
            payload = {
              ...payload,
              ...this.filterVideos,
              audience_type: this.customContentVideosEnabled
                ? this.filterVideos.audience_type
                : null,
            }
            await this.getAllVideos(payload)
            results = this.getVideoList.results
            totalItems = this.getVideoList.count
            break
          }
          case 'Pass':
            payload = { ...payload, ...this.filterPasses }
            await this.getAllPasses(payload)
            results = this.getPassList.results
            totalItems = this.getPassList.count
            break
          case 'Quiz':
            payload = { ...payload, ...this.filterQuizzes }
            await this.getAllQuizzes(payload)
            results = this.getQuizList.results
            totalItems = this.getQuizList.count
            break
          case 'Learning Path':
            payload = {
              ...payload,
              instructors__in: this.filterLPaths.instructors,
              learning_areas__in: this.filterLPaths.learning_areas,
              categories__in: this.filterLPaths.categories,
              tags__name__in: this.filterLPaths.tags,
              vendor: this.filterLPaths.vendor,
              difficulty: this.filterLPaths.difficulty,
              status: this.filterLPaths.status,
              is_featured: isNil(this.filterLPaths.is_featured)
                ? this.filterLPaths.is_featured
                : this.filterLPaths.is_featured.toString(),
              page_size: this.pageSize.toString(),
              closing_video_jwplayer_id:
                this.filterLPaths.closing_video_jwplayer_id,
            }
            await this.getAllLPaths(payload)
            results = this.getLPathList.results
            totalItems = this.getLPathList.count
            break
          case 'Exercise':
            payload = { ...payload, ...this.filterExercises }
            await this.getAllExercises(payload)
            results = this.getExerciseList.results
            totalItems = this.getExerciseList.count
            break
          case 'Lab':
            payload = { ...payload, ...this.filterLabs }
            await this.getAllLabs(payload)
            // await this.getAllLabs({ ...payload, is_featured: 'true' })
            results = this.getLabList.results
            totalItems = this.getLabList.count
            break
          case 'iFrame':
            payload = { ...payload, ...this.filterIFrames }
            await this.getAllIFrames(payload)
            results = this.getIFrameList.results
            totalItems = this.getIFrameList.count
            break
          case 'Collection':
            payload = {
              ...payload,
              learning_areas__in: this.filterCollections.learning_areas,
              categories__in: this.filterCollections.categories,
              tags__name__in: this.filterCollections.tags,
              vendor: this.filterCollections.vendor,
              difficulty: this.filterCollections.difficulty,
              status: this.filterCollections.status,
              is_featured: isNil(this.filterCollections.is_featured)
                ? this.filterCollections.is_featured
                : this.filterCollections.is_featured.toString(),
              has_cc: isNil(this.filterCollections.has_cc)
                ? this.filterCollections.has_cc
                : this.filterCollections.has_cc.toString(),
              has_sample_content: isNil(
                this.filterCollections.has_sample_content
              )
                ? this.filterCollections.has_sample_content
                : this.filterCollections.has_sample_content.toString(),
              page_size: this.pageSize.toString(),
            }
            await this.getAllCollections(payload)
            results = this.getCollectionList.results
            totalItems = this.getCollectionList.count
            break
          case 'Skill Sonar':
            payload = { ...payload, ...this.filterSonar }
            await this.getAllSonarAssessments(payload)
            results = this.getSonarList.results
            totalItems = this.getSonarList.count
            break
          default:
            break
        }
        this.items[this.typeSelected].items = results
        this.items[this.typeSelected].totalItems = totalItems
        payload.content_type = this.typeSelected
        if (
          !this.withSelection &&
          !isEqual(this.$route.query, omitBy(payload, isEmpty))
        ) {
          this.$router.replace({
            name: 'content',
            query: omitBy(payload, isEmpty),
          })
        }
      } catch (error) {
        this.$vs.loading.close('.search-async-api-data > .con-vs-loading')
        this.showError(error)
      }
      this.$vs.loading.close('.search-async-api-data > .con-vs-loading')
    },
    getItemMetadata(item) {
      if (this.typeSelected === 'Collection') {
        return { learning_paths: (item.learning_paths || []).map((lp) => lp.id) }
      }
      return item.metadata
    },
    checkSelected(id) {
      if (
        this.itemsSelected &&
        this.itemsSelected[this.typeSelected] &&
        this.itemsSelected[this.typeSelected].length
      ) {
        return this.itemsSelected[this.typeSelected].includes(id)
      }
    },
    getVideoReferenceName(ref) {
      const reference = ref.split('/')
      return reference[reference.length - 1]
    },
    resolveEditRoute(item) {
      const name = resolveEditPathByType(this.typeSelected, this.$router)
      if (!name) return {}
      return {
        name,
        params: { id: item.id },
      }
    },
    goToItemClicked(e) {
      if (
        !this.withSelection &&
        !this.relatedContentByType.hasOwnProperty(this.typeSelected)
      ) {
        const route = this.resolveEditRoute(e)
        if (!route.name) return
        this.$router.push(route)
      }
      if (this.relatedContentByType.hasOwnProperty(this.typeSelected)) {
        if (this.rowsOpened.includes(e.id)) {
          // close the row
          const index = this.rowsOpened.indexOf(e.id)
          if (index > -1) {
            this.rowsOpened.splice(index, 1)
          }
        } else {
          this.openRow(e)
        }
      }
    },
    fillResultsWithStore() {
      this.items = {
        Course: {
          items: this.getCourseList.results || [],
          totalItems: this.getCourseList.count || 0,
        },
        Video: {
          items: this.getVideoList.results || [],
          totalItems: this.getVideoList.count || 0,
        },
        Pass: {
          items: this.getPassList.results || [],
          totalItems: this.getPassList.count || 0,
        },
        Quiz: {
          items: this.getQuizList.results || [],
          totalItems: this.getQuizList.count || 0,
        },
        'Learning Path': {
          items: this.getLPathList.results || [],
          totalItems: this.getLPathList.count || 0,
        },
        Exercise: {
          items: this.getExerciseList.results || [],
          totalItems: this.getExerciseList.count || 0,
        },
        Lab: {
          items: this.getLabList.results || [],
          totalItems: this.getLabList.count || 0,
        },
        iFrame: {
          items: this.getIFrameList.results || [],
          totalItems: this.getIFrameList.count || 0,
        },
        Collection: {
          items: this.getCollectionList.results || [],
          totalItems: this.getCollectionList.count || 0,
        },
        'Skill Sonar': {
          items: this.getSonarList.results || [],
          totalItems: this.getSonarList.count || 0,
        },
      }
    },
    async restoreQuerySearch() {
      const query = this.$route.query
      if (
        query.company !== this.getSelectedCompany &&
        query.company !== this.getSelectedCompanyName &&
        query.content_type !== 'Exercise'
      ) {
        this.$router.replace({ name: 'content' })
        return
      }
      this.typeSelected = query.content_type
      if (query.ids) {
        //Need to change query bc come with an array on one element instead a string
        query.ids =
          Array.isArray(query.ids) && query.ids.length === 1
            ? query.ids.join()
            : query.ids
        this.name = [query.ids].join()
      } else if (query.name__icontains) {
        this.name = query.name__icontains
      }
      switch (this.typeSelected) {
        case 'Course':
          this.filterCourses.instructors = query.instructors__in
          this.filterCourses.learning_areas = query.learning_areas__in
          this.filterCourses.categories = query.categories__in
          this.filterCourses.tags = query.tags__name__in
          this.filterCourses.vendor = query.vendor
          this.filterCourses.difficulty = query.difficulty
          this.filterCourses.status = query.status
          this.filterCourses.is_featured = isNil(query.is_featured)
            ? query.is_featured
            : query.is_featured === 'true'
          this.filterCourses.has_cc = isNil(query.has_cc)
            ? query.has_cc
            : query.has_cc === 'true'
          if (this.customContentCoursesEnabled) {
            this.filterCourses.audience_type =
              query.audience_type === CUSTOM_CONTENT_AUDIENCE_TYPES.PUBLIC ||
              query.audience_type === CUSTOM_CONTENT_AUDIENCE_TYPES.CUSTOM
                ? query.audience_type
                : null
            if (
              this.filterCourses.audience_type ===
                CUSTOM_CONTENT_AUDIENCE_TYPES.CUSTOM &&
              query.business_account_ids
            ) {
              const selectedAccountIds = Array.isArray(query.business_account_ids)
                ? query.business_account_ids.join(',').split(',')
                : `${query.business_account_ids}`.split(',')
              this.filterCourses.business_account_ids = selectedAccountIds.filter(
                Boolean
              )
            } else {
              this.filterCourses.business_account_ids = []
            }
          } else {
            this.filterCourses.audience_type = null
            this.filterCourses.business_account_ids = []
          }
          this.pageSize = Number(query.page_size)
          break
        case 'Video':
          this.filterVideos.instructor_id = query.instructor_id
          this.filterVideos.type = query.type
          this.filterVideos.audience_type =
            this.customContentVideosEnabled &&
            (query.audience_type === CUSTOM_CONTENT_AUDIENCE_TYPES.PUBLIC ||
              query.audience_type === CUSTOM_CONTENT_AUDIENCE_TYPES.CUSTOM)
              ? query.audience_type
              : null
          this.filterVideos.s3_video_url = query.s3_video_url
          break
        case 'Pass':
          break
        case 'Quiz':
          this.filterVideos.video_reference = query.video_reference
          break
        case 'Learning Path':
          this.filterLPaths.instructors = query.instructors__in
          this.filterLPaths.learning_areas = query.learning_areas__in
          this.filterLPaths.categories = query.categories__in
          this.filterLPaths.tags = query.tags__name__in
          this.filterLPaths.vendor = query.vendor
          this.filterLPaths.difficulty = query.difficulty
          this.filterLPaths.status = query.status
          this.filterLPaths.is_featured = isNil(query.is_featured)
            ? query.is_featured
            : query.is_featured === 'true'
          this.pageSize = Number(query.page_size)
          this.filterLPaths.closing_video_jwplayer_id =
            query.closing_video_jwplayer_id
          break
        case 'Exercise':
          this.filterExercises.instructor_id = query.instructor_id
          break
        case 'Lab':
          this.filterLabs.lab_type = query.lab_type
          this.filterLabs.status = query.status
          this.filterLabs.is_lab_experience = query.is_lab_experience
          this.filterLabs.is_featured = query.is_featured
          this.filterLabs.is_skill_check = query.is_skill_check
          this.filterLabs.severity = query.severity
          this.filterLabs.year = query.year
          this.filterLabs.cve = query.cve
          break
        case 'iFrame':
          this.filterIFrames.type = query.type
          break
        case 'Bootcamp':
          this.filterBootcamps.instructor = query.instructor
          this.filterBootcamps.status = query.status
          this.filterBootcamps.registration_open = isNil(
            query.registration_open
          )
            ? query.registration_open
            : query.registration_open === 'true'
          break
        case 'Collection':
          this.filterCollections.learning_areas = query.learning_areas__in
          this.filterCollections.categories = query.categories__in
          this.filterCollections.tags = query.tags__name__in
          this.filterCollections.vendor = query.vendor
          this.filterCollections.difficulty = query.difficulty
          this.filterCollections.status = query.status
          this.filterCollections.is_featured = isNil(query.is_featured)
            ? query.is_featured
            : query.is_featured === 'true'
          this.filterCollections.has_cc = isNil(query.has_cc)
            ? query.has_cc
            : query.has_cc === 'true'
          this.filterCollections.has_sample_content = isNil(
            query.has_sample_content
          )
            ? query.has_sample_content
            : query.has_sample_content === 'true'
          this.pageSize = Number(query.page_size)
          break
        case 'Skill Sonar':
          break
        default:
          break
      }
      this.ordering = query.ordering || null
      // @ToDo: Do we have to restore the page?
      await this.searchContent({
        ordering: this.ordering,
      })
    },
    async openRow(row) {
      this.rowsLoading.push(row.id)
      this.rowsOpened.push(row.id)

      const index = this.rowsLoading.indexOf(row.id)
      if (index > -1) {
        this.rowsLoading.splice(index, 1)
      }
    },
    readableStatus(status) {
      return (
        status.charAt(0).toUpperCase() +
        status.slice(1).toLowerCase().replace(/_/g, ' ')
      )
    },
  },
  beforeDestroy() {
    this.cancelSearchEnterpriseAccountsDebounced()
  },
  created() {
    this.searchEnterpriseAccountsDebounced = debounce(async (search, loading) => {
      const updateLoading =
        typeof loading === 'function' ? loading : () => {}
      try {
        this.enterpriseAccountsLoading = true
        const { response, stale } = await loadEnterpriseAccounts({
          searchBusinessAccounts: this.searchBusinessAccounts,
          loaderState: this.enterpriseAccountsLoaderState,
          query: search,
        })
        if (!stale) {
          this.mergeEnterpriseAccountOptions(response.results || [])
        }
      } catch (error) {
        this.notifyEnterpriseAccountsLoadError()
      } finally {
        this.enterpriseAccountsLoading = false
        updateLoading(false)
      }
    }, 350)
  },
  async mounted() {
    if (this.filterTypeOptions && this.filterTypeOptions.length) {
      this.typeSelected = this.filterTypeOptions[0]
    }
    if (!this.withSelection && !isEmpty(this.$route.query)) {
      await this.restoreQuerySearch()
    }
    try {
      this.fillResultsWithStore()
      if (!this.withSelection) {
        this.$vs.loading({
          container: '.course-async-api-data',
          scale: 0.6,
        })

        // @mixin
        await this.getBasicData()

        this.$vs.loading.close('.course-async-api-data > .con-vs-loading')
      }
      if (this.videoOptions.length) {
        this.filterVideos.type = this.videoOptions[0]
        this.items['Video'] = {
          items: [],
          totalItems: 0,
        }
      }
    } catch (error) {
      this.showError(error)
    }
  },
  watch: {
    filterTypeOptions: function () {
      if (this.filterTypeOptions && this.filterTypeOptions.length) {
        this.typeSelected = this.filterTypeOptions[0]
      }
    },
    customContentCoursesEnabled: function (newValue) {
      if (newValue) return
      this.filterCourses.audience_type = null
      this.filterCourses.business_account_ids = []
      this.enterpriseAccountsSearchTerm = ''
      this.cancelSearchEnterpriseAccountsDebounced()
      this.enterpriseAccountsLoading = false
    },
    customContentVideosEnabled: function (newValue) {
      if (newValue) return
      this.filterVideos.audience_type = null
    },
    'filterCourses.audience_type': function (newValue) {
      if (newValue === CUSTOM_CONTENT_AUDIENCE_TYPES.CUSTOM) return
      this.filterCourses.business_account_ids = []
      this.enterpriseAccountsSearchTerm = ''
      this.cancelSearchEnterpriseAccountsDebounced()
      this.enterpriseAccountsLoading = false
    },
  },
}
</script>
<style lang="scss">
.content-list {
  .open-item .vs-collapse-item--content {
    overflow: unset;
  }
  .vs-input--input.normal {
    padding: 0.628rem !important;
  }
  .vs-con-loading__container {
    position: relative;
    overflow: unset;
  }
}
</style>
